import { createMachine } from 'xstate'
// const MainKioskMachine =
/** @xstate-layout N4IgpgJg5mDOIC5QFkCCBJAcgfQMoFEAVAVQAUBiAewDsEBDCAWwEtaAnMAKzAGMAXANoAGALqJQAB0qxmfZjXEgAHogBsAdgA0IAJ6IAzOqEA6ACxD1+gJwBGUwFYAHKdOPVAX3fa0WPETJUtBDMsDw01LyCoopSMnIKSMqIAExCNibJyRpW9jbqqqr2Vtp6COnqxjn6yY5GyfbJNrWmnt4YOAQkFDQIYdQR-JDCYomxsvLUiiplVcb6RQuN9kJWQqYliDbJrSA+Hf7dtH0DfEM2I5LS4wmg0xobCJlFxiumlvrWRi47e35dgfQmKwEBAwAAbMCnBB8SgAazA1GGMSu8UmiTuWl0iFyVmMWQ01SEQkcqXsHi8u3afwCUEo0LpDBYiOioxREymakxpWSVlUZiEqnMLgcTksPypnQCHDBlAYCAkdBgSNZcXZ6MQAFo7DYHjYGrj7C5HIZeUaPuLfJLSMYAMIAeUwmHwNsIWAA4thUMRCAAJO0AJXQAC13cYsOhCNgANLoO24KPkCA0MDGVgANzhKd+VttDqdLvdnu9fsDIcwbrDmAj0dj8YQ6coPDoqOGysuqpuSQQjjyc3UyyE9n0xqcDgehr5NlNK1sVnUjns9gt+y6ucdztd5aLvoDwdDTvwABFPYfkL5SPh-WfcLhY5gAX0AGbMKDysBsFhRC4gMaojllapTEqAU9TWUwcnUcDdR5ew5mWLYwKEQx1G2ClswONd803D0vR3UtQ1wO0bSjIhsHtdcXWwAB1CMfWwQg7RI+8kwiVNqAzeFjHQ1dyKwwtcJLPdy2MQjiNI3iN2o2j6MY-BMHrdjG2bCZWxZdtrjRW4UiHZI8SaSDDBcIRGl1dQbD5Vxki+EkiSqZdqWtCSCy3ATdzLCtRJIyMnMjGjfRkpjyHfNhKDYYwJDBZtH1CxguIlDCfP44s3IIoivLIvNJL8uiGKYhSMybFtRDbH82U7aZ+wqVZVGSUxqkcKwsiyXVBQsrZXBqj5BUMeyc0Slzkvw4TPPEzKXUTZM2I4rN4p4sbsO3QT3JEtLRoowh8qUoqRBK381S07tUmMPVVCnDqLAFdYsQArZjFUIkticEcSSXNDZrITCNySvChI81bvPmoK2BCsKIqimK4stBL5u+pbUrEgH1s2wqVOKtTSo7TSuxs46yTOtwLsFXVllgnIrFMGx5isqd9F66H1thlLhMvf0AwyhmHXIJRYD4ZsUzoR9TjYAAKAchAASnIbiPv6nDBt+4wWbZxKHV2sqsemHGTvx+6jCJ667CcMwigcQ3iT1Om5oZgafuW1AADFCEvbALyvasRsICbWJ5vnIZXGWYZtuHhIdp3-Rdy8z0jD21cx-9TFUfRjAXKxDGHaxTtO3V0kcO7Kce-JUhqy2A+tuXbdDUPnddqO8H+20ABk43wdm+IdbA7QvHAnSouuEa9lMG046XHMD8vg4rKvw5r9365tJuCFbr7287uTsB7vuvOR5SaFU789vKzY6jMZwakycxVlqbOVju3lTqslwTtetooatvig6ZyfHeryPZ4Rxvm5LwLCvLu698C9w9kDEG4VIp8Gih+P2DlPrOXHp-YwU8I5u2jnPBeLcVY4FXt3cBm8iDb22rHDS-48jGRPqYM+tUVjEi5JsAUukpyCgavUXI9h1Al1HmXRaaCMEz2wf-eegD8Ed1ARvSBwVQowPBggkeyCFquSGl-MOmDa4ewAYvSRhCwEQP+mQ1GO1zjIjjuqMox9XB0JJAwy+zCyhPFvoUXItRyb6FUI4PhKjGbqPQd-aev9RFeV0XgmGIC14yPrkrf0XMfanGMALIWosiQSylu9fh79UEBOESEkhhBwlANdFEohRj-5xIoX+KxyR9CU2AqdBqtgPi2GSNBeorjFz6U8d43xstBF5KCVov+YTcCoAAGot1ymvJuNpUAN1wAxf0qA3T4AHlNTMiC+pj0GQrfJWDCkiUmdM2SOA5kLKWQGVZ+ATG7zRvvdWVCbGn3sRfJhxN5hdOJA4dQ+QFz9N2Wo-ZwyRFHPGVMgKsyiKXOWTcqB8iwZwIhsogZwK7agoKToiFpymLYAuYsuFay7nMh2ujA+Gsj40NsfQ95V8DauFzuwicw5KbVUBQI9FoYJkLPQIeVATsoX3mqftLslMapwVTlYRqbgGg1HHDkMwCdzAEy8bUHxb1X6lxyXs5aPKG58oFbiuS5ABDmJVJQqx4rdLzClTKwomRHDjnAkqxO7wthZDsBynVXLmb+lZuHSR2UhUJN5kklJ740lEklqioF8tlpxJKXeKS-kZmYBFYfBAlVGm1Xqo1GqqhiZWFzm0hoFMeFZDJBy+26A3TEEDMJcMiMa11obW6DZQ8Zpav4S2+toYm3s17W2kle8LGWoOvU4klRvHSryPUP5+hdTVFgsZMyXj9B1VWFkatta+2NqrM23dbaO2KWHlktcQ7+0HsHUe90I7irmvUjUg6NQHDGG4UUJCw4hROuulkMyxhLBrDcEYPUWwd2tqvdWcil7ywItBrA+BsVY2YFgxWAdMHb3lnvWSx5liJ052nc0udPDLAtVqJURwSECheO8fdFomr-Y9qwxWf0+BUCHgAJrYD5Q3FuMY4wJhYoPU9XamMXpY8YNjHHuO8f47WKMOGM2UseKsEwH7VgfGcMBh4dT5x4n0MZZwGgc6Jwg3u1j7GuM8cPHxmsgmT3TW2fTNDUmrOyds-JwTSnH0Y3HV2HkRJ316k-Vpn9umrK6SAxuqcF1jLmbbW5mTNm7MCfjPBhRyKlHnsw5B4S0nrNyfs3WBsKN7m4bHc+rsXjaqUZcEOcyhR6Xcj04BwzMXVhGGMuSF+4ncsWaS4VzzxWEw9CfC+eUABXWAAALZT-4atAWLfV+pBRRS6e1IBhdfyjB1EKAl0MBWPOpYUw+Ggz5XwSGm3N3zFKFs1SW84Bwq2mtONzSYKjSFaj1GLUSHrlJu0SbyxWA8x5csjbO9QC7U3ZvzdqQuWCGmv3adcLphofJ+xeMgjUeCVgDvCVBzej0aXRtHHOxNq7sPbtPKseYXILx5w1BqjUHsAo0d0OTkOFCRJLD9i9YxpB-XEs2h9M6KM2B9V8qJ6a8lNOX2yuC4uTT36dMGznLiVwwHi2LhTv9lDrmRdi6JzxzAYd9Wht9hGkWYsY05YdAb0XxFjdYDNwsuHBGp28mIyhUji6DaChMJr2qNQ-luBsJ4Ck1BKCgngIkEelXRXTCnLqBcjSKYLgQnkPXdvOXxvdAnzN1gPtFDTsaXk5kdTXRVcdXk8wi+Nd4QLnZueK77urCTgvKm6q5xTqXjOFeHjgVgqoWvZJi1ZAcHOb1X0P4BMJxxs8OAZ43jvJ3qhFgk7PY9RX8wbODbVBsO+nklg3BZE09PlBur4bpR8imnKZy1+09cJz1OJ-+9Z39wKMw7VnD5DnPUC-VRPPYaf6EpR-A6BwHvEvN-cvD-UoNlXSVIcmC+OwRwDxQA-xBWRNfBcAsVCwNhFYGrJhMyBoXUcCXSOqIodQcmIcAoNIDA2fEFTRMFD2XApPe6CyV5c+RhZrRAbTGvB1DPVINIZ+AHPrONVvDRH+Q5HRcRPRSJAhaRYhVgi1Krdgw0WhWlHgpxRqCoEfQUaVKyNA+YBjXrQXCQieQJZgrFHBCRBQqRaJZQ+uJtNgzYNwXOEfBocyOoNwcmbODQAQnhSyQcDdUwsQ8wlvSwg5bRWw+QjmRQxwipMJQ8B0fAVwx4PUEtECU6eYVdMcA2AUPQymOpS+Gqag1CMw5vH1YAqQ4JGQ2IiJeIhw8pI5OJdIxoSCfkU6IwIcWwdIewDpICfQmqZYZAhcMIlDaoyQqw6QmI-+HFIVfFGFQla5NZdI8yDQmlN5bQ6CRVZlOwMyecfICYnPKYqIzFeo+Yk5RYglK5FZNZSsCMdYv5ICSwOhAoIyIoMgnkLpEfaoWqNA8PJvemM4oRC4uYsZa4tNJY+ZFY+4-AYwFIp0dYucEwZbLIYkedPUYoBlVOPOVbahKccmDVSokEmfXJBWSXflQVNNdYvIJOWoZYBOEkROLIX9UoQ0WCdhIgzHbIBgikhNf1ZWew4NWk1QxPFhG+FOCmQccyamP3eAxOXEEkWwcg5dQUUQ-XFjdo-ICoJHMLVXeA1rBoMyWyVwUPEk8I5vVzDDe3bU8UzNGoPURXULFXVHA2IoG1dreoU6YtepRvUkq2VzI7FLLzeMdohcXSfUt09klICwXEIDe6FYLYEffHSzZLIrEnR4wgdIwzU6PEJCOwROS6YtQtP9RoICOpQcJqXWJYNMwbY7MMqMYwBiF2G5EbT0U3QMVATAXMjdWCBqQcXINYSCE6CLZ-KsuqTIEfBONYeskMzMhTFsu0NstZDs+eYgJZS8Pst9Qc7pEc8tMs7kOvNrJCfsL9Q0E4wHIXfcfAI8Y3DvB0lTYcIcPOOcSmRcHkBqXTbqZOOLIwYtKfYEoMyTQ3J3KkonXMxqQ-OhUkdIaVHhI8lIbEswUkCmXUyCMzYC0uB3I3cHF3S8fVCM8wF05XFHWMx4F4u6Y0Sg2wBqROK88TBfc8G5do8yd9BOB7QwJoY0CiqyTfS6JYRqaVAoCPdwIAA */
export const KioskMachine = createMachine({
  id: 'MAIN_SETUP',
  initial: 'CONNECTING_AUTHORIZING',
  states: {
    CONNECTING_AUTHORIZING: {
      initial: 'INIT_KIOSK',
      states: {
        INIT_KIOSK: {
          exit: [
            'setCtxStrToken',
            'setCtxStrDeviceId'
          ],

          invoke: {
            src: 'getFromLocalStorageTokenAndDeviceId',
            onDone: [
              {
                target: 'VALIDATE_TOKEN'
              }
            ]
          },

          entry: 'toPageSetup'
        },
        NEED_ADMIN_PERMISSION: {
          description: 'qr isinya socketId dan deviceId',
          entry: 'listenSocketGranted',
          on: {
            'on:config:permit': {
              target: 'AFTER_PERMIT_SOCKET',
              actions: [
                'setCtxStrToken',
                'setCtxStrDeviceId',
                'saveLocalStorageDeviceAndToken'
              ],
              description: 'event ini membawa datanya berupa token'
            }
          }
        },
        SOCKET_CONNECT_WITH_TOKEN: {
          entry: 'enableCtxManualConnecting',
          invoke: {
            src: 'openSocketConnection',
            onDone: [
              {
                target: '#MAIN_SETUP.CONFIGURING',
                actions: [
                  'setCtxBoolConnected',
                  'setCtxStrSocketId',
                  'disableCtxManualConnecting'
                ]
              }
            ],
            onError: [
              {
                target: 'ERROR_CONNECTION_WITH_TOKEN'
              }
            ]
          }
        },
        SOCKET_CONNECT: {
          description: 'socket disconnect and connect , get new socket id',
          entry: [
            'deleteCtxStrToken',
            'enableCtxManualConnecting'
          ],
          invoke: {
            src: 'openSocketConnection',
            onDone: [
              {
                target: 'NEED_ADMIN_PERMISSION',
                actions: [
                  'setCtxBoolConnected',
                  'setCtxStrSocketId',
                  'disableCtxManualConnecting'
                ]
              }
            ],
            onError: [
              {
                target: 'ERROR_CONNECTION',
                actions: 'setCtxBoolDisconnected'
              }
            ]
          }
        },
        ERROR_CONNECTION: {
          description: 'apabila tidak bisa terhubung , maka akan mencoba connect',
          after: {
            5000: {
              target: '#MAIN_SETUP.CONNECTING_AUTHORIZING.SOCKET_CONNECT',
              actions: [],
              internal: false
            }
          }
        },
        AFTER_PERMIT_SOCKET: {
          states: {
            CLOSE_CONNECTION_OPEN_NEW_SOCKET: {
              invoke: {
                src: 'closeSocketOpenNewConnection',
                onDone: [
                  {
                    target: '.DONE'
                  }
                ],
                onError: [
                  {
                    target: '.DONE',
                    cond: 'isAlreadyClose'
                  },
                  {
                    target: '.ERROR'
                  }
                ]
              },
              initial: 'INIT',
              states: {
                INIT: {},
                DONE: {
                  type: 'final'
                },
                ERROR: {
                  after: {
                    5000: {
                      target: '#MAIN_SETUP.CONNECTING_AUTHORIZING.AFTER_PERMIT_SOCKET.CLOSE_CONNECTION_OPEN_NEW_SOCKET',
                      actions: [],
                      internal: false
                    }
                  }
                }
              }
            },
            SAVE_TOKEN_LOCALSTORAGE: {
              invoke: {
                src: 'saveTokenToLocalstorage',
                onDone: [
                  {
                    target: '.DONE'
                  }
                ],
                onError: [
                  {
                    target: '.DONE'
                  }
                ]
              },
              initial: 'INIT',
              states: {
                INIT: {},
                DONE: {
                  type: 'final'
                }
              }
            }
          },
          type: 'parallel',
          onDone: {
            target: 'VALIDATE_TOKEN'
          }
        },
        VALIDATE_TOKEN: {
          always: [
            {
              target: 'SOCKET_CONNECT_WITH_TOKEN',
              cond: 'hasCtxToken'
            },
            {
              target: 'SOCKET_CONNECT'
            }
          ]
        },
        ERROR_CONNECTION_WITH_TOKEN: {
          after: {
            5000: {
              target: '#MAIN_SETUP.CONNECTING_AUTHORIZING.SOCKET_CONNECT_WITH_TOKEN',
              actions: [],
              internal: false
            }
          }
        }
      }
    },

    CONFIGURING: {
      initial: 'INIT_CONFIGURING',
      states: {
        INIT_CONFIGURING: {
          invoke: {
            src: 'getAPIAwaitDeviceConfig',
            onDone: [
              {
                target: 'READY_IDLE_KIOSK',
                cond: 'isValidKiosk',
                actions: 'setCtxObjConfigKiosk',
                description: 'dapet callback data berupa json config nya\n'
              },
              {
                target: 'NEED_CONFIG_KIOSK',
                actions: 'deleteCtxObjConfigKiosk'
              }
            ],
            onError: [
              {
                target: 'CHECK_CONFIG_INTERVAL'
              }
            ]
          }
        },
        READY_IDLE_KIOSK: {
          invoke: {
            src: 'saveConfigToLocalStorage',
            onDone: [
              {
                target: '.TO_PAGE_KIOSK_CLUSTER',
                cond: 'isKioskCluster'
              },
              {
                target: '.TO_PAGE_KIOSK_ANTRIAN',
                cond: 'isKioskAntrian'
              }
            ],
            onError: [
              {
                target: 'NEED_CONFIG_KIOSK'
              }
            ]
          },
          initial: 'INIT',
          states: {
            INIT: {},
            TO_PAGE_KIOSK_ANTRIAN: {
              entry: 'toPageKioskAntrian'
            },
            TO_PAGE_KIOSK_CLUSTER: {
              entry: 'toPageKioskCluster'
            }
          },
          on: {
            'on:config:push': [
              {
                target: 'CHECK_VALID_CONFIG',
                cond: 'isValidKiosk',
                actions: 'setCtxObjConfigKiosk'
              },
              {
                target: 'NEED_CONFIG_KIOSK',
                actions: 'deleteCtxObjConfigKiosk'
              }
            ]
          }
        },
        NEED_CONFIG_KIOSK: {
          entry: 'toPageSetup',
          on: {
            'on:config:push': [
              {
                target: 'READY_IDLE_KIOSK',
                cond: 'isValidKiosk',
                actions: 'setCtxObjConfigKiosk'
              },
              {
                actions: 'deleteCtxObjConfigKiosk'
              }
            ]
          }
        },
        CHECK_VALID_CONFIG: {
          always: {
            target: 'READY_IDLE_KIOSK'
          }
        },
        CHECK_CONFIG_INTERVAL: {
          after: {
            5000: {
              target: '#MAIN_SETUP.CONFIGURING.INIT_CONFIGURING',
              actions: [],
              internal: false
            }
          }
        }
      }
    },

    ADMIN_PAGE: {
      entry: 'toPageAdmin'
    }
  },
  on: {
    'on:admin:reject': {
      target: '.CONNECTING_AUTHORIZING.INIT_KIOSK',
      actions: [
        'toPageSetup',
        'deleteLocalStorageKiosk',
        'deleteCtxObjConfigKiosk'
      ]
    },

    'on:disconnect': {
      actions: 'setCtxBoolDisconnected'
    },

    'on:connected': [
      {
        cond: 'isManualConnecting',
        actions: 'setCtxBoolConnected'
      },
      {
        target: '.CONFIGURING',

        actions: [
          'setCtxBoolConnected',
          'setCtxStrSocketId'
        ],

        internal: false
      }
    ],

    'on:admin:delete:token': {
      target: '.CONNECTING_AUTHORIZING.INIT_KIOSK',
      cond: 'isSameToken',
      actions: [
        'toPageSetup',
        'deleteCtxObjConfigKiosk',
        'deleteLocalStorageOnlyToken'
      ]
    },

    'go:to:admin': '.ADMIN_PAGE',

    'reload:page': {
      target: '#MAIN_SETUP',
      actions: 'refreshPage',
      internal: true
    }
  },
  context: {
    connected: false,
    token: null,
    deviceId: null,
    manualConnecting: false,
    socket: null,
    config: {}
  },
  predictableActionArguments: true,
  preserveActionOrder: true
})
